import { create } from 'zustand';
import type { Quotation } from '../types';
import { db, isFirebaseActive, removeUndefined } from '../firebase';
import { ref, set as dbSet } from 'firebase/database';

interface QuotationState {
  quotations: Quotation[];
  addQuotation: (quotation: Quotation) => Promise<void>;
  updateQuotation: (id: string, updates: Partial<Quotation>) => Promise<void>;
  deleteQuotation: (id: string) => Promise<void>;
}

export const useQuotationStore = create<QuotationState>()((set) => ({
  quotations: [],

  addQuotation: async (quotation) => {
    set((state) => ({
      quotations: [quotation, ...state.quotations]
    }));

    if (isFirebaseActive && db) {
      dbSet(ref(db, `quotations/${quotation.id}`), removeUndefined(quotation)).catch((e: any) => {
        console.error('Failed to add quotation:', e);
        alert('Error syncing quotation to database: ' + (e.message || e));
      });
    }
  },

  updateQuotation: async (id, updates) => {
    let quotationToSync: Quotation | undefined;

    set((state) => {
      const newQuotations = state.quotations.map((q) => {
        if (q.id === id) {
          const updated = { ...q, ...updates };
          quotationToSync = updated;
          return updated;
        }
        return q;
      });
      return { quotations: newQuotations };
    });

    if (isFirebaseActive && db && quotationToSync) {
      dbSet(ref(db, `quotations/${id}`), removeUndefined(quotationToSync)).catch((e: any) => {
        console.error('Failed to update quotation:', e);
        alert('Error updating quotation in database: ' + (e.message || e));
      });
    }
  },

  deleteQuotation: async (id) => {
    set((state) => ({
      quotations: state.quotations.filter((q) => q.id !== id)
    }));

    if (isFirebaseActive && db) {
      dbSet(ref(db, `quotations/${id}`), null).catch(console.error);
    }
  }
}));
